import { render, staticRenderFns } from "./OrgTreeItem.vue?vue&type=template&id=0904e40e&scoped=true&"
import script from "./OrgTreeItem.vue?vue&type=script&lang=js&"
export * from "./OrgTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./OrgTreeItem.vue?vue&type=style&index=0&id=0904e40e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904e40e",
  null
  
)

component.options.__file = "OrgTreeItem.vue"
export default component.exports